<script setup>

import { inject, ref, watch, provide } from 'vue';
import Section from '@/components/elementsRapport/Section.vue';
import FilArianeSection from '@/components/centre/panelRapport/FilArianeSection.vue';

const { rapport } = defineProps({
	rapport: Object
});

const gererToucheClavierRapport = inject('gererToucheClavierRapport');

const sectionSelectionnee = inject('sectionSelectionnee');
const composantSection = ref(null);

watch(() => rapport.focus, focus => {
	if (focus) {
		composantSection.value.focus();
	}
});

function donnerFocusAuRapport() {
	rapport.focus = true;
}

provide('donnerFocusAuRapport', donnerFocusAuRapport);

</script>

<template>
	<FilArianeSection
		:section-principale="rapport.sectionPrincipale"
		:section-selectionnee="sectionSelectionnee" />
	<div class="panel-rapport" 
		ref="composantSection"
		tabindex=0 
		@keydown="gererToucheClavierRapport($event)"
		@focus="rapport.focus = true"
		@blur="rapport.focus = false">
			<Section v-if="sectionSelectionnee" :section="sectionSelectionnee" />
	</div>
</template>

<style scoped>

.panel-rapport {
	padding: 8px;
}

</style>